import { Component, OnInit , ViewChild} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})

// @ViewChild('placesRef') placesRef:  GooglePlaceDirective;


export class RegisterComponent implements OnInit {
  registerErrors: string;
  registerForm = new FormGroup({
    email: new FormControl('', [
      Validators.required,
    ]),
    name: new FormControl('', [
      Validators.required,
    ]),
    contact: new FormControl('', [
      Validators.required,
      Validators.minLength(10),
      Validators.maxLength(10)
    ]),
    website: new FormControl('', [
      Validators.required,
    ]),
    account: new FormControl('', [
      Validators.required,
      Validators.minLength(13),
      Validators.maxLength(13)
    ]),
    MMnumber: new FormControl('', [
      Validators.required,
      Validators.minLength(10),
      Validators.maxLength(10)
    ]),
    location: new FormControl('', [
      Validators.required,
    ]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
    ]),
  });
  location: Address;
  options = {
      types: [],
      componentRestrictions: { country: 'UG' }
  };
  constructor(private authService: AuthService , private router: Router) { }

  ngOnInit() {
  }
  public handleAddressChange(address: Address) {
  //  this.registerForm.controls.location.setValue(address.name);
  this.location = address;
}
  register() {
    console.log(this.registerForm.value);
    // Todo: call this.authService.register(); remember to update location;
    this.router.navigate(['auth/login']);
}
}
